export default __webpack_public_path__ + "3c0e049ad78f5bdaba7cdc53b8788068.png";